import React, {useState} from 'react'
import {subDays} from 'date-fns'
import {Box} from '@mui/material'
import WhatsAppComm from '../dashboard/whatsapp'
import DashboardDateFilter, {DateRangeCaption} from '../../common/DashboardDateFilter'
import PageTitle from '../../common/PageTitle'
import withLayout from '../../hocs/Layout'
import {pageContainerSx, filterBarSx} from '../../styles/patterns'

function WhatsAppConversations() {
  const [dateRange, setDateRange] = useState([{
    endDate: new Date(), startDate: subDays(new Date(), 7), key: 'selection',
  }])

  return (
    <Box sx={pageContainerSx}>
      <PageTitle subTitle="Customer NDR conversations over WhatsApp — reattempt confirmations, address corrections & RTO authorizations">WhatsApp Conversations</PageTitle>
      <Box sx={{...filterBarSx, display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 1.5}}>
        <DateRangeCaption dateRange={dateRange} />
        <DashboardDateFilter dateRange={dateRange} maxDate={new Date()} onChange={(range) => setDateRange(range)} />
      </Box>
      <WhatsAppComm tab={9} dateRange={dateRange} />
    </Box>
  )
}

export default withLayout(WhatsAppConversations)
